/**
 * To avoid merge conflicts, please add new params to a random location (not the last line).
 */
export enum queryParams {
  LNG = 'lang',
  SELLER_EMAIL = 'sellerEmail',
  RATING = 'rating',
  /** Letter of the offer alternative the page shows instead of the deal vehicle. */
  ALTERNATIVE = 'alternative',
  SESSION_ID = 'sessionId',
  OPENED_BY = 'openedBy',
}

export const ONLINE_OFFER_SESSION_ID_STORAGE_KEY_PREFIX = 'online-offer-session-id';
export const BUYING_ONLINE_OFFER_SESSION_ID_STORAGE_KEY_PREFIX = 'buying-online-offer-session-id';

/**
 * To avoid merge conflicts, please add new params to a random location (not the last line).
 */
